/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Duplicate_ProductInputs */

const en_issue_duplicate_product = /** @type {(inputs: Issue_Duplicate_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this style and colour is already in the linesheet`)
};

/**
* | output |
* | --- |
* | "this style and colour is already in the linesheet" |
*
* @param {Issue_Duplicate_ProductInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_duplicate_product = /** @type {((inputs?: Issue_Duplicate_ProductInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Duplicate_ProductInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_duplicate_product(inputs)
});